import {
  AddDoctorActionTypes,
  ADD_DOCTOR_FAIL,
  ADD_DOCTOR_LOADING,
  ADD_DOCTOR_SUCCESS,
  AddDoctorState,
  ADD_DOCTOR_API_MSG,
  ADD_DOCTOR_API_RES,
} from "./ActionTypes";
import { AddDoctorResponse } from "./Model";

const initialStateEditPosts: AddDoctorState = {
  loading: false,
  addDoctorRes: {} as AddDoctorResponse,
  successMsg: "",
  errorMsg: "",
  status: 0,
};
export const addDoctorReducer = (
  state = initialStateEditPosts,
  action: AddDoctorActionTypes
): AddDoctorState => {
  switch (action.type) {
    case ADD_DOCTOR_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case ADD_DOCTOR_SUCCESS:
      return {
        ...state,
        addDoctorRes: action.payload,
        successMsg: action.successMsg,
      };
    case ADD_DOCTOR_FAIL:
      return {
        ...state,
        addDoctorRes: action.payload,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case ADD_DOCTOR_API_MSG:
      return {
        ...state,
        addDoctorRes: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case ADD_DOCTOR_API_RES:
      return {
        ...state,
        addDoctorRes: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    default:
      return state;
  }
};